import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { OdooBitacoraService, OdooDatosTecnicos, OdooEventoVista } from 'src/app/services/odoo/odoo-bitacora.service';
import { mensajeDeFallo } from 'src/app/services/odoo/odoo.service';

/** Texto de duración: «320 ms» o «1,2 s». */
export function duracionTexto(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return '—';
  return ms < 1000 ? `${ms} ms` : `${(ms / 1000).toFixed(1).replace('.', ',')} s`;
}

/** Frase de cómo contestó Odoo. */
export function respuestaSimple(m: Pick<OdooEventoVista, 'ok' | 'status'>): string {
  if (m.ok) return 'Odoo contestó que todo estuvo bien.';
  if (!m.status) return 'Odoo no llegó a contestar.';
  return `Odoo contestó que no (código ${m.status}).`;
}

/**
 * Detalle de UN evento de la bitácora de Odoo: «Qué pasó», cuánto tardó, quién, código HTTP, «Lo que se envió» y
 * «Lo que respondió Odoo». Lo usan la Bitácora y los historiales del cliente y del comercio (un solo lugar).
 * <od-evento-detalle [evento]="m"></od-evento-detalle>                      → pide lo técnico a /bitacora/:id/tecnico
 * <od-evento-detalle [evento]="m" [datos]="t"></od-evento-detalle>          → usa lo técnico que ya llegó con el historial
 */
@Component({
  selector: 'od-evento-detalle',
  templateUrl: './od-evento-detalle.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OdEventoDetalleComponent implements OnChanges, OnDestroy {
  @Input() evento: OdooEventoVista | null = null;
  /** Lo enviado/respondido ya conocido; si no viene, se pide por el id del evento. */
  @Input() datos: OdooDatosTecnicos | null = null;

  cargando = false;
  error: string | null = null;
  tecnico: OdooDatosTecnicos | null = null;
  private sub: Subscription | null = null;

  constructor(private api: OdooBitacoraService, private cdr: ChangeDetectorRef) {}

  ngOnChanges(): void {
    this.sub?.unsubscribe();
    this.error = null;
    if (this.datos) { this.tecnico = this.datos; this.cargando = false; return; }
    this.tecnico = null;
    const id = this.evento?._id;
    if (!id) { this.cargando = false; return; }
    this.cargando = true;
    this.sub = this.api.tecnico(id).subscribe({
      next: (d) => { this.tecnico = d; this.cargando = false; this.cdr.markForCheck(); },
      error: (e: unknown) => { this.error = mensajeDeFallo(e); this.cargando = false; this.cdr.markForCheck(); },
    });
  }

  ngOnDestroy(): void { this.sub?.unsubscribe(); }

  readonly duracion = duracionTexto;
  readonly respuestaSimple = respuestaSimple;
}
